<div nz-col nzSpan="24">
  <div class="summary-row">
    <span class="title">
      Industry Analysis
    </span>
    <span class="subtitle">
      We have hundreds of pre-built comp tables available, with several for
      nearly every industry. See below for a breakout by industry and our
      company coverage
    </span>
  </div>
</div>
<div nz-col nzSpan="12">
  <div class="summary-row">
    <nz-skeleton [nzLoading]="loading" [nzActive]="true" [nzParagraph]="false">
      <span class="template-count">{{ indystryAnalysisTemplatesCount }}</span>
      <span class="template-title">Industry Analysis Templates</span>
      <nz-divider class="divider" nzType="vertical"></nz-divider>
      <span class="companies-count">{{ companiesCoveredCount }}</span>
      <span class="companies-title">Companies Covered</span>
    </nz-skeleton>
  </div>
</div>
